<template>
  <div class="crm-features">
    <img :src="items[indexOpen].img" class="screen">

    <div class="icons">
      <div
        v-for="(item, index) in items"
        v-bind:key="index"
        :class="['icon', item.name, index == indexOpen ? 'active' : '']"
        v-on:click="openItem(index)"
      >
      </div>
    </div>

    <div class="h2 title">
      {{items[indexOpen].title}}
    </div>

    <div class="description" v-html="items[indexOpen].description">
    </div>
  </div>
</template>

<script>
const PATH = "/static-public/assets/components/crm-features/";

export default {
  data() {
    return {
      indexOpen: 0,
      items: [
        {
          name: 'schedule',
          title: 'График работы сотрудников',
          img: '/static-public/assets/components/crm-features/screens/schedule.png',
          description: `
            <p>Наша система позволяет гибко формировать график сотрудников с возможностью задания нескольких рабочих интервалов.</p>
            <p>А в мобильном приложении ПрофиГид Мастер сотрудники всегда могут видеть свое актуальное расписание.</p>
          `
        },
        {
          name: 'crm',
          title: 'Клиентская база и система лояльности',
          img: '/static-public/assets/components/crm-features/screens/clients.png',
          description: `
            <p>Ваша клиентская база - ваше богатство! Не теряйте контакты.</p>
            <p>Наша система позволяет группировать пользователей по фокус-группам и отправлять им персонализированные предложения по SMS и в WhatsApp.</p>
            <p>Вы сможете анализировать конверсию и увеличивать эффективность маркетинговых кампаний, обеспечивая рост вашего бизнеса.</p>
          `
        },
        {
          name: 'salary',
          title: 'Мгновенный и точный расчет заработной платы',
          img: '/static-public/assets/components/crm-features/screens/salary.png',
          description: `
            <p>Наша система позволяет легко рассчитывать заработную плату сотрудников за любой период времени, основываясь на объеме выполненных ими услуг.</p>
            <p>Вы сможете сохранить платежные ведомости в истории выплат, обеспечивая прозрачность и надежность в учете заработной платы.</p>
          `
        },
        {
          name: 'catalog',
          title: 'Управление услугами и товарами',
          img: '/static-public/assets/components/crm-features/screens/services.png',
          description: `
            <p>Созданный в системе единый каталог услуг будет отображаться в CRM и на формах онлайн записи для клиентов.</p>
            <p>Благодаря централизации данных вы сможете легко управлять ценами и видеть аналитику по оказанным услугам.</p>
          `
        },
        {
          name: 'permissions',
          title: 'Одна система, разные роли',
          img: '/static-public/assets/components/crm-features/screens/permissions.png',
          description: `
            <p>В системе предусмотрены три действующие роли - Администратор сети, администратор салона и мастер.</p>
            <p>В зависимости от роли вы можете настраивать уровни доступа, например есть возможность скрыть для мастеров контакты клиентов.</p>
          `
        },
        {
          name: 'products',
          title: 'Складской учет и фискальные чеки',
          img: '/static-public/assets/components/crm-features/screens/wms.png',
          description: `
            <p>Подсистема складского учета позволяет контролировать остатки на складе и оформлять поставки новых расходных материалов.</p>
            <p>А благодяря интеграции с сервисом КОМТЕТ Касса вы можете подключить к каждому своему салону онлайн кассу и выдавать фискальные чеки непосредственно из CRM.</p>
          `
        },
      ]
    }
  },

  methods: {
    openItem(index) {
      this.indexOpen = index;
    }
  }
}
</script>

<style lang="scss">
.crm-features {
  margin: 0 auto;
  text-align: center;
  max-width: 1015px;
  padding: 0px 30px 50px 30px;

  .screen {
    max-width: 100%;
    margin-bottom: 30px;
  }

  .icons {
    display: flex;
    justify-content: space-around;
    margin-bottom: 50px;

    .icon {
      width: 78px;
      height: 78px;
      background-size: cover !important;

      &:hover {
        cursor: pointer;
      }

      &.schedule {
        background: url("/static-public/assets/components/crm-features/schedule_white.svg") no-repeat center top;

        &:hover,
        &.active {
          background: url("/static-public/assets/components/crm-features/schedule_dark.svg") no-repeat center top;
        }
      }

      &.crm {
        background: url("/static-public/assets/components/crm-features/crm_white.svg") no-repeat center top;

        &:hover,
        &.active {
          background: url("/static-public/assets/components/crm-features/crm_dark.svg") no-repeat center top;
        }
      }

      &.catalog {
        background: url("/static-public/assets/components/crm-features/catalog_white.svg") no-repeat center top;

        &:hover,
        &.active {
          background: url("/static-public/assets/components/crm-features/catalog_dark.svg") no-repeat center top;
        }
      }

      &.salary {
        background: url("/static-public/assets/components/crm-features/salary_white.svg") no-repeat center top;

        &:hover,
        &.active {
          background: url("/static-public/assets/components/crm-features/salary_dark.svg") no-repeat center top;
        }
      }

      &.permissions {
        background: url("/static-public/assets/components/crm-features/permissions_white.svg") no-repeat center top;

        &:hover,
        &.active {
          background: url("/static-public/assets/components/crm-features/permissions_dark.svg") no-repeat center top;
        }
      }

      &.products {
        background: url("/static-public/assets/components/crm-features/products_white.svg") no-repeat center top;

        &:hover,
        &.active {
          background: url("/static-public/assets/components/crm-features/products_dark.svg") no-repeat center top;
        }
      }
    }
  }

  .title {
    margin-bottom: 30px;
  }

  @media (max-width: 992px) {
    .icons {
      .icon {
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CrmFeatures.vue